import { ThemeProvider } from "@mui/material";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import PrescriptionList from "../../../components/screen/patientCare/prescriptionHistory/PrescriptionList";
import { theme } from "../../../components/constants/muiTheme";

const PrescriptionHistoryListPage = () => {
  return (
    <PageTemplate
      header="Prescription History"
      mainComponent={
        <ThemeProvider theme={theme}>
          <PrescriptionList />
        </ThemeProvider>
      }
      pageRole={26}
    />
  );
};

export default HOC(PrescriptionHistoryListPage);
